/*
 * Session-engine API endpoints (the 60bjnqzpe4 "NewPracticeLearnCombo" gateway)
 * — the ONE place the Development/Production stage is decided (2026-08-30).
 *
 * Stage resolution, highest priority first:
 *   1. REACT_APP_API_STAGE       force a stage explicitly (put it in .env.local
 *                                — gitignored — e.g. to smoke-test Production
 *                                locally, or set per-branch in Amplify to give
 *                                a branch preview the Development stage)
 *   2. NODE_ENV                  CRA sets this automatically: `npm start` =
 *                                development -> Development stage (dev alias,
 *                                $LATEST); `npm run build` (what Amplify runs)
 *                                = production -> Production stage (prod alias,
 *                                pinned versions)
 *
 * So every branch carries identical code: local runs always hit Development,
 * deployed builds always hit Production, and nobody ever swaps URLs by hand.
 * Going live with new lambda code = publish-version + update-alias prod — not
 * a frontend change.
 *
 * Per-endpoint REACT_APP_*_URL overrides still win over everything (legacy
 * escape hatch; keep them OUT of the committed .env — .env.local only).
 *
 * Scope: ONLY the session-engine endpoints. The claude-* API bases
 * (StudentDashboardV3/TeacherDashboardV3 data/api.js, uiFlags) and all legacy
 * gateways are deliberately not routed through here. The full diagnostic's
 * legacy endpoints reuse API_STAGE from Diagnostic/diagnosticUrls.js.
 */

export const API_STAGE = process.env.REACT_APP_API_STAGE
  || (process.env.NODE_ENV === 'development' ? 'Development' : 'Production');

// The gateway's CORS list allows only http://localhost:3000. Local dev on a
// *.localhost subdomain (s1.localhost:3001, s2.localhost:3001... so several
// test accounts stay signed in side by side) goes same-origin through the
// setupProxy path, whose rewrite targets the same stage. Plain localhost and
// builds never take this branch.
const DEV_VIA_PROXY = process.env.NODE_ENV === 'development'
  && typeof window !== 'undefined'
  && /\.localhost$/.test(window.location.hostname);

const BASE = DEV_VIA_PROXY
  ? '/teacher-api-proxy'
  : `https://60bjnqzpe4.execute-api.us-east-1.amazonaws.com/${API_STAGE}`;

export const DOMAIN_SESSION_URL = process.env.REACT_APP_DOMAIN_SESSION_URL || `${BASE}/domain/session`;
export const PRACTICE_QUESTIONS_URL = process.env.REACT_APP_PRACTICE_QUESTIONS_URL || `${BASE}/practice/questions`;
export const SESSION_START_URL = process.env.REACT_APP_SESSION_START_URL || `${BASE}/session/start`;
export const LEARN_DATA_URL = process.env.REACT_APP_LEARN_DATA_URL || `${BASE}/learn/data`;
export const LEARN_PROGRESS_URL = process.env.REACT_APP_LEARN_PROGRESS_URL || `${BASE}/learn/progress`;

// claude-* APIs on the same gateway (added 2026-08-30): same dev/prod alias
// wiring, so they stage-swap identically. (Teacher dev traffic still rides the
// setupProxy same-origin path for CORS — the proxy's rewrite is stage-aware.)
export const STUDENT_API_URL = `${BASE}/student/api`;
export const USER_API_URL = `${BASE}/user/api`;
export const TEACHER_API_URL = `${BASE}/teacher/api`;
// Curriculum Connect (2026-10-17): claude-curriculum-api, same gateway + stage wiring.
export const CURRICULUM_API_URL = `${BASE}/curriculum/api`;
export const ADMIN_API_URL = `${BASE}/admin/adminAPI`;
// Placement moved off its function URL onto the gateway (2026-08-30): same
// dev/prod alias staging as the rest, no overrides.
export const PLACEMENT_API_URL = `${BASE}/placement/api`;
